import { Country } from "@sso/types";

import { ssoApi } from "..";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

const softwareApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.COUNTRIES] }).injectEndpoints({
  endpoints: builder => ({
    countries: builder.query<Country[], void>({
      query: () => ({ url: `${Endpoints.COUNTRIES}` }),
      providesTags: [CacheKeys.COUNTRIES],
    }),
  }),
});

export const { useCountriesQuery } = softwareApi;
